// import Navbar   from "../../components/c_navbar";
import Menu     from "../../components/Menu/menu.jsx";
// import Busca    from   "../../components/Busca/c_busca.jsx";
// import SideBar from "../../components/Menu/SideBar/c_sidebar.jsx";
import './alterardadosperfil.css';



function PerfilFoto (){
    return <>
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                    {/* <Navbar /> */}
                    <Menu page="perfilalterar"/>
                    {/* <SideBar/> */}
                </div>
                <div className="col py-3 me-3">
                    {/* <Busca/> */}
                    <h1>Código de Validação</h1>
                    <p>Digite o Código de Validação</p>
                    <h4>Salvar Dados</h4>
                    <hr />
                    <p>Salvar minhas credenciais</p>
                    <hr />
                    <p>Não recebeu o código de validação?</p>
                    <p>Clique para reenviar</p>
                </div>
            </div>

        </div>
    </>
}

export default PerfilFoto;